import utils from 'utils';

import {Checkbox, FormControlLabel} from '@mui/material';

export const UiCheckbox = (props: {
    onChange: (value: boolean) => void,
    disabled?: boolean,
    checked?: boolean,
    defaultChecked?: boolean,
    label?: React.ReactNode,
    hidden?: boolean,
}) => {
    return <FormControlLabel className={cmpClass}
        control={
            <Checkbox
                className={
                    classMap.input +
                    (props.hidden ? ' ' + classMap.hidden : '')
                }
                onChange={(e) => props.onChange(e.target.checked)}
                disabled={props.disabled}
            />
        }
        label={props.label}
        checked={props.checked}
        defaultChecked={props.defaultChecked}
    />;
};

const cmpClass = 'ui-checkbox';
const classMap = utils.generateClassMap(cmpClass, {
    input: 'input',
    hidden: 'hidden',
});
